export default __webpack_public_path__ + "static/media/430cf150689adf84a25056883eafa478.470cb118.png";